// 错题中心
export default [
  {
    path: "/mistakesCenter", //错题中心
    meta: {
      title: "错题中心"
    },
    component: () => import("@/views/mistakes/index"),
    children: [
      {
        path: "", //首页
        meta: {
          keepAlive: true,
          title: "错题中心",
        },
        component: () => import("@/views/mistakes/mistakesCenter"),
      },
      {
        path: "mistakesList", 
        meta: {
          title: "错题列表",
        },
        component: () => import("@/views/mistakes/mistakesList"),
      },
      {
        path: "examPreview", //试卷详情
        meta: {
          title: "试卷详情"
        },
        component: () => import("@/views/mistakes/examPreview")
      }
      ,
      {
        path: "mistakesPreview", //错题预览
        meta: {
          title: "错题预览"
        },
        component: () => import("@/views/mistakes/mistakesPreview")
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/mistakes.js